import React from "react";
import { RecurringStatus, SalesStatus } from "../../../../@types/invoice";
import { ServiceStatus } from "../../../../@types/service";
import { ServiceStatuses, Statuses } from "../../../../constants";

export const getStatusClass = (status: SalesStatus) => {
  const normalizedStatus = (status ?? "").toLowerCase();

  switch (normalizedStatus) {
    case "paid":
      return "text-[#039855] cursor-pointer text-[14px] rounded-[20px] py-2 ";
    case "pending":
      return "text-[#DC6803] cursor-pointer text-[14px] rounded-lg   py-2 ";
    case "draft":
      return "text-[#344054] cursor-pointer text-[14px] rounded-[20px] py-2  px-2 py-2 ";
    case "due":
      return "text-[#D92D20] cursor-pointer text-[14px] rounded-[20px]   py-2 ";
      return "text-[#D92D20] cursor-pointer text-[14px]  w-[45px]";
    case "cancelled":
      return "text-[#D92D20] cursor-pointer text-[14px] rounded-[20px]  py-2  ";
    case "refunded":
      return "text-[#044E97] cursor-pointer text-[14px] rounded-[20px]  py-2 ";
    case "active":
      return "text-[#C89000] cursor-pointer text-[14px]";
    case "expired":
      return "text-[#C800A8] cursor-pointer text-[14px] rounded-[20px] py-2 px-3  px-2";
    case "quote":
      return "text-[#B36100] cursor-pointer text-[14px] rounded-[20px] py-2  px-2";
    default:
      return "";
  }
};

export const getStatusColor = (status: SalesStatus) => {
  const normalizedStatus = (status ?? "").toLowerCase();

  switch (normalizedStatus) {
    case "paid":
      return "#ECFDF3";
    case "pending":
      return "#FFFAEB";
    case "draft":
      return "#F2F4F7";
    case "due":
      return "";
    case "cancelled":
      return "#FEF3F2";
    case "refunded":
      return "#C9EBF3";
    case "active":
      return "#ECFDF3";
    case "expired":
      return "#FDB0FF";
    case "quote":
      return "#FFC785";
    default:
      return "";
  }
};

export const customTextColors = {
  paid: "#039855",
  pending: "#FF6702",
  draft: "##4E4E4E",
  overdue: "#D92D20",
  cancelled: "#101010",
  refunded: "#044E97",
  expired: "#C800A8",
  active: "#C89000",
  quote: "#B36100",
  paused: "#4E4E4E",
};

export const customColors = {
  paid: "#D1FADF",
  pending: "#FFFAEB",
  draft: "#F2F4F7",
  overdue: "#FEE4E2",
  cancelled: "#7D7D7D",
  refunded: "#C9EBF3",
  expired: "#FDB0FF",
  active: "#FFFCB0",
  quote: "#FFC785",
  paused: "#4E4E4E",
};

export const getServiceStatusClass = (status: ServiceStatus) => {
  switch (status) {
    case ServiceStatuses.ACTIVE:
      return "text-[#12B76A] text-[14px] w-fit px-[6px] py-[2px] rounded-[4px] border border-gray-300";
    case ServiceStatuses.PENDING:
      return "text-gray-700 text-[14px] w-fit px-[6px] py-[2px] rounded-[4px] border border-gray-300";
    case ServiceStatuses.INACTIVE:
      return "text-[#4E4E4E] text-[14px] w-fit px-[6px] py-[2px] rounded-[4px] border border-gray-300";
    default:
      return "";
  }
};

export const getServiceStatusColor = (status: ServiceStatus) => {
  switch (status) {
    case ServiceStatuses.ACTIVE:
      return "";
    case ServiceStatuses.PENDING:
      return "#E6C8B3";
    case ServiceStatuses.INACTIVE:
      return "#F2F4F7";
    default:
      return "";
  }
};

export const getRecurringStatusClass = (status: RecurringStatus) => {
  switch (status) {
    case Statuses.ACTIVE:
      return "text-[#039855] shadow-md hover:shadow-md cursor-pointer rounded-md text-[14px] w-[58px]";
    case Statuses.PAUSED:
      return "text-[#344054] shadow-md hover:shadow-md cursor-pointer rounded-md text-[14px] w-[60px] ";
    case Statuses.CANCELLED:
      return "text-[#D92D20] shadow-md hover:shadow-md cursor-pointer rounded-md text-[14px] w-[72px] ";
    case Statuses.EXPIRED:
      return "text-[#DC6803] shadow-md hover:shadow-md cursor-pointer rounded-md text-[14px] w-[72px] ";
    default:
      return "";
  }
};

export const getRecurringStatusColor = (status: RecurringStatus) => {
  switch (status) {
    case Statuses.ACTIVE:
      return "#ECFDF3";
    case Statuses.PAUSED:
      return "#F2F4F7";
    case Statuses.CANCELLED:
      return "#FEF3F2";
    case Statuses.EXPIRED:
      return "#FFFAEB";
    default:
      return "";
  }
};

export const customRecurringTextColors = {
  active: "#088306",
  paused: "#4E4E4E",
  cancelled: "#FB0303",
  expired: "#C800A8",
};

export const customRecurringColors = {
  active: "#B5CDB4",
  paused: "#C5C5C5",
  cancelled: "#E5B4B4",
  expired: "#FDB0FF",
};
